<template>
  <div>
    <ClickLimits
      v-model="clicksHourly"
      class="mt-1"
      type="clicks_hourly"
      @update:modelValue="update"
      @remove="remove"
    />
    <ClickLimits
      v-model="clicksDaily"
      class="mt-1"
      type="clicks_daily"
      @update:modelValue="update"
      @remove="remove"
    />
    <ClickLimits
      v-model="clicksTotal"
      class="mt-1"
      type="clicks_total"
      @update:modelValue="update"
      @remove="remove"
    />
    <BudgetLimits
      v-model="budgetHourly"
      class="mt-1"
      type="budget_hourly"
      :validation-key="CampaignValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
    <BudgetLimits
      v-model="budgetDaily"
      class="mt-1"
      type="budget_daily"
      :validation-key="CampaignValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
    <BudgetLimits
      v-model="budgetTotal"
      class="mt-1"
      type="budget_total"
      :validation-key="CampaignValidationErrorsKey"
      @update:modelValue="update"
      @remove="remove"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import {
  computedForCampaignLimits,
  defineUpdateCampaignLimits,
  defineRemoveCampaignLimits
} from '@/utils/limits'
import ClickLimits from './ClickLimits.vue'
import BudgetLimits from '@/components/BudgetLimits.vue'

import { CampaignValidationErrorsKey } from '@/api/types'

export default defineComponent({
  name: 'CampaignLimits',
  components: {
    ClickLimits,
    BudgetLimits
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const clicksHourly = computed(
      computedForCampaignLimits('clicks_hourly', props)
    )
    const clicksDaily = computed(
      computedForCampaignLimits('clicks_daily', props)
    )
    const clicksTotal = computed(
      computedForCampaignLimits('clicks_total', props)
    )
    const budgetHourly = computed(
      computedForCampaignLimits('budget_hourly', props)
    )
    const budgetDaily = computed(
      computedForCampaignLimits('budget_daily', props)
    )
    const budgetTotal = computed(
      computedForCampaignLimits('budget_total', props)
    )

    const update = defineUpdateCampaignLimits(props, context)
    const remove = defineRemoveCampaignLimits(props, context)

    return {
      clicksHourly,
      clicksDaily,
      clicksTotal,
      budgetHourly,
      budgetDaily,
      budgetTotal,
      update,
      remove,
      CampaignValidationErrorsKey
    }
  }
})
</script>
